'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _transliteration = require("transliteration");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _WithRouter = _interopRequireDefault(require("Components/WithRouter"));
var _Editor = _interopRequireDefault(require("Components/TextEditor/Editor"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getFormJSON = _interopRequireDefault(require("Components/Forms/Functions/getFormJSON"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
const _excluded = ["images"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const {
  app,
  moment
} = window;
class NewsForm extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      status_messages: {},
      'news[date]': moment().format('YYYY-MM-DD')
    });
    (0, _defineProperty2.default)(this, "handleChange", _handleChange.default.bind(this));
    (0, _defineProperty2.default)(this, "handleFileChange", _handleFileChange.default.bind(this));
    (0, _defineProperty2.default)(this, "fetchNews", () => {
      const component = this,
        props = this.props,
        state = this.state;
      component.setState({
        loading: true
      });
      qwest.post('/news/get-all', {
        id: props.id || document.location.pathname.split((0, _Routing.URL)('AdminNewsDashboard') + '/')[1],
        with_count: false
      }).then(function (xhr, response) {
        let _ref = response.data[0] || {},
          {
            images
          } = _ref,
          news = (0, _objectWithoutProperties2.default)(_ref, _excluded);
        const update = (0, _getStateFromObject.default)({
          data: news,
          model: 'news'
        });
        component.setState(_objectSpread(_objectSpread({}, update), {}, {
          'news[images]': images,
          '__files-news[images]': images,
          loading: false
        }));
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
    (0, _defineProperty2.default)(this, "validate", async e => {
      const component = this,
        props = this.props,
        state = this.state;
      if (state.loading === true) return;
      component.setState({
        loading: true
      });
      const news = (0, _getFormJSON.default)({
        state: state,
        pattern: 'news['
      });
      const action_str = props.type === 'update' ? 'UpdateNews' : 'CreateNews';
      let response;
      try {
        response = await (0, _ajaxRequest.default)((0, _Routing.action)(action_str), {
          data: news
        });
      } catch (errors) {
        return component.setState(errors);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: response.error,
        warning: response.warning,
        statement: response.statement,
        status_messages: {}
      });
      if (props.type === 'update') {
        component.fetchNews();
      } else {
        component.clearForm();
        component.setState({
          info: (response.info || '') + ' redirection...'
        });
        window.setTimeout(function () {
          props.navigate((0, _Routing.URL)('AdminNewsDashboard'));
        }, 1600);
      }
    });
    (0, _defineProperty2.default)(this, "clearForm", () => {
      const component = this,
        props = this.props,
        state = this.state;
      const update = Object.keys(state).filter(key => key.startsWith('news[')).reduce(function (update, key) {
        if (_is_js.default.string(state[key])) {
          update[key] = '';
        } else if (_is_js.default.array(state[key])) {
          update[key] = [];
        } else if (_is_js.default.json(state[key])) {
          update[key] = {};
        }
        return update;
      }, {});
      component.setState(_objectSpread(_objectSpread({}, update), {}, {
        '__files-news[images]': [],
        'news[images]': []
      }));
    });
    (0, _defineProperty2.default)(this, "editUrl", _ref2 => {
      let {
        e,
        value,
        name
      } = _ref2;
      const component = this,
        props = this.props,
        state = this.state;
      let url = (value || '').split('/').map(function (chunk) {
        chunk = chunk.split('-').join(' ');
        if (chunk.endsWith(' ')) {
          return (0, _transliteration.slugify)(chunk.trim()) + '-';
        } else {
          return (0, _transliteration.slugify)(chunk.trim());
        }
      }).join('/');
      if (url.startsWith('/') === false) url = '/' + url;
      component.handleChange({
        e,
        value: url,
        name
      });
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchNews();
    }
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/news/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['news[title]'],
      name: "news[title]",
      label: "Titre",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleChange,
      value: state['news[test]'],
      name: "news[test]",
      label: "Test",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      onChange: component.handleFileChange,
      value: state['news[images]'],
      name: "news[images]",
      model: "news",
      field: "images",
      label: "Image(s) d'illustration",
      status: state.status_messages,
      multiple: true,
      accept: "image",
      public: true
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_Editor.default, {
      onChange: component.handleChange,
      value: state['news[description]'],
      name: "news[description]",
      label: "Description courte de l'actualit\xE9",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_Editor.default, {
      onChange: component.handleChange,
      value: state['news[content]'],
      name: "news[content]",
      label: "Contenu de l'actualit\xE9",
      status: state.status_messages
    }))), status), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "submit",
      onClick: component.validate,
      className: (0, _bemit.default)('c-flat-btn', ['primary'])
    }, props.type === 'update' ? 'Enregistrer' : 'Créer cette actualité', loader)));
    return output;
  }
}
var _default = exports.default = (0, _WithRouter.default)(NewsForm);
